import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.34 1.27H6.67a3.63 3.63 0 0 0-3.94 4v8.23a1.22 1.22 0 0 0 .69 1.14 1.13 1.13 0 0 0 .48.11 1.33 1.33 0 0 0 .84-.33C5 14.25 6.7 13 8 12.05c1.31.93 3.06 2.2 3.27 2.37a1.34 1.34 0 0 0 .85.33 1.12 1.12 0 0 0 .47-.11 1.21 1.21 0 0 0 .69-1.14V5.22a3.63 3.63 0 0 0-3.94-3.95Zm2.44 11.65c-.9-.66-2.76-2-3.29-2.36h-.05l-.18-.08a.63.63 0 0 0-.44 0l-.12.06a.09.09 0 0 0-.07 0c-.46.33-2.41 1.72-3.34 2.4V5.22a2.13 2.13 0 0 1 2.38-2.45h2.67a2.13 2.13 0 0 1 2.44 2.45Z';
const draw24px =
  'M14,2.16H10c-3.51,0-5.52,2-5.52,5.55v12.4a1.44,1.44,0,0,0,.81,1.37,1.24,1.24,0,0,0,.56.13,1.61,1.61,0,0,0,1-.41c.33-.28,3.09-2.27,5.12-3.72,2,1.44,4.8,3.44,5.13,3.72a1.61,1.61,0,0,0,1,.41,1.39,1.39,0,0,0,.56-.13,1.44,1.44,0,0,0,.81-1.37V7.71C19.53,4.18,17.51,2.16,14,2.16ZM18,20c-.78-.62-4.82-3.5-5.52-4l-.06,0a.61.61,0,0,0-.21-.11.57.57,0,0,0-.22,0h0a.57.57,0,0,0-.22,0,.71.71,0,0,0-.21.11l-.06,0c-.69.49-4.58,3.26-5.53,4V7.71c0-2.69,1.35-4,4-4h4c2.67,0,4,1.36,4,4.05Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BookmarkIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bookmark'),
) as IconWithRender;

BookmarkIcon.displayName = 'BookmarkIcon';
BookmarkIcon.propTypes = Icon.propTypes;
BookmarkIcon.renderIcon = (props) => <BookmarkIcon {...props} />;
export default BookmarkIcon;
